const defaultConfig = require('tailwindcss/defaultConfig');

const responsiveVariants = ['sm', 'md', 'lg', 'xl', '2xl', 'responsive'];

const themeColours2025 = {
    'blue': '#BEE2EF',
    'light-blue': '#DDEFF6',
    'pink': '#FAD1E3',
    'dark-pink': '#F6AECD',
    'hot-pink': '#E24072',
    'orange': '#F1832F',
    'lime-green': '#C6CC2E',
    'beige': '#FEEAD2',
    'light-beige': '#FFF6ED',
    'off-white': '#FFFAF4',
    'grey': '#58595B',
};

module.exports = {
    theme: {
        colors: {
            'primary': themeColours2025.orange,
            'secondary': '#e2f5f9',
            'transparent': 'transparent',
            'black': themeColours2025.grey,
            'white': '#ffffff',
            'green-light': '#51d88a',
            'green-lighter': '#B0D6BD',
            'green-lightest': '#cdf5da',
            'grey': '#b8c2cc',
            'grey-dark': themeColours2025.grey,
            'grey-darker': '#706f6f',
            'grey-darkest': '#3d4852',
            'grey-light': '#dae1e7',
            'grey-lighter': '#e8e8eb',
            'grey-lightest': '#f8fafc',
            'blue-100': '#dcf1ee',
            'orange-light': '#faad63',
            'pink': '#d60461',
            'pink-light': '#ec65a2',
            'pink-lighter': themeColours2025['hot-pink'],
            'pink-500': '#f1637a',
            'pink-400': '#f3a5ae',
            'pink-200': themeColours2025['dark-pink'],
            'pink-100': '#F8F2EE',
            'peach': '#f48581',
            'beige-100': themeColours2025['off-white'],
            'beige-200': themeColours2025['light-beige'],
            'beige-300': themeColours2025.beige,
            'red-dark': '#7f2a27',
            'red-light': '#ef5753',
            'red-lightest': '#f6d5d5',
            'paypal-blue': '#003087',

            // 2025 Theme Colors
            '2025-blue': themeColours2025.blue,
            '2025-light-blue': themeColours2025['light-blue'],
            '2025-pink': themeColours2025.pink,
            '2025-dark-pink': themeColours2025['dark-pink'],
            '2025-orange': themeColours2025.orange,
            '2025-lime-green': themeColours2025['lime-green'],
            '2025-hot-pink': themeColours2025['hot-pink'],
            '2025-beige': themeColours2025.beige,
            '2025-light-beige': themeColours2025['light-beige'],
            '2025-off-white': themeColours2025['off-white'],
            '2025-grey': themeColours2025.grey,
        },
        screens: {
            'xs': '480px',
            'sm': '576px',
            'md': '768px',
            'lg': '992px',
            'xl': '1200px',
            '2xl': '1400px',
        },
        fontFamily: {
            script: [
                'Mellony Dry Brush',
                'serif',
            ],
            sans: [
                'Raleway',
                'sans-serif',
            ],
            heading: [
                'gelica',
                'sans-serif',
            ],
            leading: [
                'Raleway',
                'sans-serif',
            ],
        },
        fontSize: {
            'xs': '0.75rem',
            'sm': '0.875rem',
            'base': '1rem',
            'lg': '1.125rem',
            'xl': '1.25rem',
            '2xl': '1.5rem',
            '3xl': '1.875rem',
            '4xl': '2.25rem',
            '5xl': '3rem',
            '6xl': '4rem',
        },
    },
    plugins: [
        require('glhd-tailwindcss-transitions')(),
        require('@tailwindcss/typography'),
    ],
    content: [
        './pages/**/*.{js,jsx,ts,tsx,vue}',
        './components/**/*.{js,jsx,ts,tsx,vue}',
        './layouts/**/*.{js,jsx,ts,tsx,vue}',
    ],
    safelist: [
        'text-center',
        {
            pattern: /^grid-cols-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^col-start-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^col-span-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^row-span-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^grid-cols-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^-?[mp][trblxy]-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^gap-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^w-/,
            variants: responsiveVariants,
        },
        {
            pattern: /^text-/,
        },
        {
            pattern: /^font-/,
        },
        {
            pattern: /^bg-/,
        },
    ],
};
